import { COLOR, Dart, DART_COLOR } from "../types/dart";

export function getColor(dart: Dart): COLOR {
  let color = COLOR.BLACK;
  DART_COLOR.Green.forEach(({ number, multiplier }) => {
    if (number === dart.number && multiplier === dart.multiplier)
      color = COLOR.GREEN;
  });
  DART_COLOR.White.forEach(({ number, multiplier }) => {
    if (number === dart.number && multiplier === dart.multiplier)
      color = COLOR.WHITE;
  });
  DART_COLOR.Red.forEach(({ number, multiplier }) => {
    if (number === dart.number && multiplier === dart.multiplier)
      color = COLOR.RED;
  });
  DART_COLOR.Black.forEach(({ number, multiplier }) => {
    if (number === dart.number && multiplier === dart.multiplier)
      color = COLOR.BLACK;
  });
  return color;
}

export function isColor(dart: Dart, color: COLOR): boolean {
  let isColor = false;
  DART_COLOR[color].forEach(({ number, multiplier }) => {
    if (number === dart.number && multiplier === dart.multiplier)
      isColor = true;
  });
  return isColor;
}

export function allDifferentColors(darts: Dart[]): boolean {
  let redHit = 0;
  let greenHit = 0;
  let whiteHit = 0;
  let blackHit = 0;
  for (const dart of darts) {
    const dartColor = getColor(dart);
    switch (dartColor) {
      case COLOR.RED:
        redHit = 1;
        break;
      case COLOR.WHITE:
        whiteHit = 1;
        break;
      case COLOR.BLACK:
        blackHit = 1;
        break;
      case COLOR.GREEN:
        greenHit = 1;
        break;
    }
  }
  return (redHit + greenHit + whiteHit + blackHit) >= 3;
}